import cx from 'classnames'
import { ReactNode } from 'react'

interface IContainerProps {
  children: ReactNode
  className?: string
  fluid?: boolean
}

const Container = ({ children, className, fluid, ...rest }: IContainerProps) => {
  const classList = cx(
    'container',
    {
      'container-fluid': fluid
    },
    className
  )

  return (
    <div className={classList} {...rest} id='container'>
      {children}
    </div>
  )
}

export default Container
